import { lazy } from 'react';

const SendTransfersVerifierConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
		
	},
	routes: [
		{
			path: '/verifier/consult/send-transfer',
			component: lazy(() => import('./SendTransferContainer'))
		}
	]
};

export default SendTransfersVerifierConfig;


